import { defineComponent as _defineComponent } from 'vue'
import {
  AbDescription,
  AbSection,
  AbContainer,
  AbTitle,
  AbLink,
  AbIcon,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';

interface FeatureSectionPointsItem {
  text?: string;
  link?: string;
  icon?: string;
}

interface Props {
  id?: string;
  title?: string;
  description?: string;
  items?: FeatureSectionPointsItem[];
  spacing?: Spacing;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionPoints',
  props: {
    id: null,
    title: { default: '' },
    description: { default: '' },
    items: { default: () => [] },
    spacing: null
  },
  setup(__props: any) {



return { __sfc: true,AbDescription, AbSection, AbContainer, AbTitle, AbLink, AbIcon }
}

})